import { IHttpApi } from '@cian/http-api/shared';
import {
  IDoNotDisturbRequest,
  fetchDoNotDisturb,
  TDoNotDisturbResponse,
} from '../../repositories/quiz/v1/do-not-disturb';

export const postDoNotDisturb = (httpApi: IHttpApi, parameters: IDoNotDisturbRequest): Promise<TDoNotDisturbResponse> =>
  fetchDoNotDisturb({ httpApi, parameters });
